import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, Switch, Route, Redirect} from 'react-router-dom';
import {Container} from 'reactstrap';

import { ToastContainer } from "react-toastify";

import Header from './components/Header/';
import Sidebar from './components/Sidebar/';
import Breadcrumb from './components/Breadcrumb/';
import Aside from './components/Aside/';
import Footer from './components/Footer/';

import DashboardManager from './dashboard/DashboardManager';
import ScheduledReplenishmentManager from './scheduledreplenishment/ScheduledReplenishmentManager';
import ReplenishmentManager from './replenishment/ReplenishmentManager';
import ModuleManager from './module/overview/ModuleManager';
import ModuleAdminManager from './module/admin/ModuleAdminManager';
import RetailerManager from './retailer/RetailerManager';
import StoreManager from './retailer/StoreManager';
import IposConfigManager from './retailer/IposConfigManager';
import AreaControlOverviewManager from './areacontrol/overview/AreaControlOverviewManager';
import AreaControlAdminManager from './areacontrol/admin/AreaControlAdminManager';
import UserManager from './user/UserManager';
import ArticleManager from './article/ArticleManager'
import SyncManager from "./sync/SyncManager";

class App extends Component {
    render() {
        return (
            <div className="app">
                <ToastContainer autoClose={2000} />
                <Header/>
                <div className="app-body">
                    <Sidebar {...this.props}/>
                    <main className="main">
                        <Breadcrumb/>
                        <Container fluid>
                            <Switch>
                                <Route path="/admin/dashboard" name="Dashboard" component={DashboardManager}/>
                                <Route path="/admin/scheduledreplenishment" name="geplante Nachversorgung" component={ScheduledReplenishmentManager}/>
                                <Route path="/admin/replenishment" name="ausgeführte Nachversorgung" component={ReplenishmentManager}/>
                                <Route path="/admin/modules/overview" name="Modulübersicht" component={ModuleManager}/>
                                <Route path="/admin/modules/admin" name="Modulverwaltung" component={ModuleAdminManager}/>
                                <Route path="/admin/retailer/iposconfig" name="Stores" component={IposConfigManager}/>
                                <Route path="/admin/retailer/stores" name="Stores" component={StoreManager}/>
                                <Route path="/admin/retailer" name="Retailer" component={RetailerManager}/>
                                <Route path="/admin/areacontrol/overview" name="Flächensteuerung" component={AreaControlOverviewManager}/>
                                <Route path="/admin/areacontrol/admin" name="Flächensteuerung" component={AreaControlAdminManager}/>
                                <Route path="/admin/admin/user" name="Benutzerverwaltung" component={UserManager}/>
                                <Route path="/admin/admin/sync" name="Benutzerverwaltung" component={SyncManager}/>
                                <Route path="/admin/article" name="Artikelverwaltung" component={ArticleManager}/>
                                <Redirect from="/admin" to="/admin/dashboard"/>
                            </Switch>
                        </Container>
                    </main>
                    <Aside/>
                </div>
                <Footer/>
            </div>
        );
    }
}

export default connect(
    state => ({ notifications: state.notifications })
)(App);



// WEBPACK FOOTER //
// ./src/admin/App.js